import _ from 'lodash'
import { useRouteQuery } from '@vueuse/router'
import type { SearchFilterOptions } from '~/composables/useSearchFilters'

export const useParseQueryParamsToSearchFilters = (
  defaultFilters:
    | ComputedRef<SearchFilterOptions | undefined>
    | Ref<SearchFilterOptions | undefined> = ref(undefined)
) => {
  const route = useRoute()
  const filters = ref<SearchFilterOptions>({})

  // Route query
  const categoriesQuery = useRouteQuery('categories')
  const citySlugQuery = useRouteQuery('citySlug')
  const datesQuery = useRouteQuery('dates')
  const searchqueryQuery = useRouteQuery('searchquery')
  const priceMaxQuery = useRouteQuery('priceMax')
  const priceMinQuery = useRouteQuery('priceMin')
  const hasAvailableDatesQuery = useRouteQuery('hasAvailableDates')
  const hasPromotion = useRouteQuery('hasPromotion')
  const typeOfClass = useRouteQuery('typeOfClass')
  // const onlineQuery = useRouteQuery('online')
  // const directEvents = useRouteQuery('directEvents')
  // const publicEvents = useRouteQuery('publicEvents')
  const languagesQuery = useRouteQuery('languages')
  const peopleAmount = useRouteQuery('peopleAmount')
  // const pageQuery = useRouteQuery('page')

  // Route Params
  // const categoryParam = useRouteParams('category')
  // const cityParam = useRouteParams('city')

  const citySlug = computed(
    () =>
      citySlugQuery.value?.toString() ?? defaultFilters.value?.city?.toString()
  )

  const updateFilters = () => {
    // filters.value.categories = categSlug ? [categSlug] : filters.value.categories
    filters.value.categories = defaultFilters.value?.categories
      ? defaultFilters.value?.categories
      : filters.value.categories || []
    filters.value.categories = _.uniq([
      ...filters.value.categories,
      ...(Array.isArray(categoriesQuery.value)
        ? categoriesQuery.value
        : categoriesQuery.value
          ? [categoriesQuery.value]
          : []
      ).map((c) => c?.toString() || ''),
    ])

    filters.value.searchquery = searchqueryQuery.value?.toString()

    if (datesQuery.value && datesQuery.value.length > 0) {
      filters.value.dates = [
        datesQuery.value[0],
        datesQuery.value[1] || datesQuery.value[0],
      ]
    }

    filters.value.city = citySlug.value

    if (route.query.priceMax) {
      filters.value.priceMax = +(priceMaxQuery.value ?? 999999)
      filters.value.priceMin = +(priceMinQuery.value ?? 0)
    }

    if (hasAvailableDatesQuery.value) {
      if (hasAvailableDatesQuery.value === 'true') {
        filters.value.hasAvailableDates = true
      } else if (hasAvailableDatesQuery.value === 'false') {
        filters.value.hasAvailableDates = false
      }
    }

    if (hasPromotion.value) {
      if (hasPromotion.value === 'true') {
        filters.value.hasPromotion = true
      }
    }

    if (typeOfClass.value) {
      filters.value.typeOfClass = typeOfClass.value
    }

    if (peopleAmount.value && Number(peopleAmount.value) > 1) {
      filters.value.peopleAmount = Number(peopleAmount.value)
    }

    if (languagesQuery.value) {
      if (Array.isArray(languagesQuery.value)) {
        filters.value.languages = languagesQuery.value as string[]
      } else {
        filters.value.languages = [languagesQuery.value]
      }
    }
  }

  watchEffect(() => updateFilters())

  return { filters }
}
